import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IInquiryCndsState, ICod0103mState, IHolidayState} from '../../models/cod/cod0103m_model';
 
const initialState: ICod0103mState = {
    originHolidays   : [],     //DB 저장 공휴일 목록 (원본)
    modifiedHolidays : [],     //화면에서 수정된 공휴일 목록
    apiHolidays      : [],     //공공 API에서 가져온 이번 달 공휴일

    thisYearGen      : false,  //올해 달력 생성 여부
    nextYearGen      : false,  //달력 생성 여부
    generatedYears   : [],     //DB에 달력 생성된 년도 리스트

    inquiryCnds: {             //조회조건
        searchYear   : new Date().getFullYear(),                   // 기본값: 올해 연도
        searchMonth  : new Date().getMonth() + 1, // 기본값: 이번 달
    },
};

export const cod0103m_Slice = createSlice({
    name: 'cod0103m_Slice',
    initialState,
    reducers: {
        setOriginHolidays: (state, action:PayloadAction<IHolidayState[]>) => {
            state.originHolidays   = action.payload;
        },
        //수정
        updateHoliday: (state, action: PayloadAction<IHolidayState>) => {
            // state.modifiedHolidays = state.modifiedHolidays.map(h =>
            //     h.baseDt === action.payload.baseDt
            //         ? {
            //             ...h,
            //             ...action.payload,
            //             dirty: true 
            //         }
            //         : h
            // );
            const exists = state.modifiedHolidays.find(h => h.baseDt === action.payload.baseDt);

            if (exists) {
                state.modifiedHolidays = state.modifiedHolidays.map(h =>
                    h.baseDt === action.payload.baseDt
                        ? {
                            ...h,
                            ...action.payload,
                            dirty: true,
                        }
                        : h
                );
            } else {
                state.modifiedHolidays.push({
                    ...action.payload,
                    dirty: true
                });
            }
        },
        //공휴일신규 추가
        addHoliday: (state, action: PayloadAction<IHolidayState>) => {
            const idx = state.modifiedHolidays.findIndex(
                h => h.baseDt === action.payload.baseDt
            );

            if (idx > -1) {
                state.modifiedHolidays[idx] = {
                    ...action.payload,
                    dirty: true,
                };
            } else {
                state.modifiedHolidays.push({
                    ...action.payload,
                    dirty: true,
                });
            }
        },
        setApiHolidays: (state, action: PayloadAction<IHolidayState[]>) => {
            state.apiHolidays = action.payload;
        },
        setCalendarStatus: (state, action: PayloadAction<{ thisYearGen   : boolean,
                                                           nextYearGen   : boolean,
                                                           generatedYears: string[] }>) => {
            const { thisYearGen, nextYearGen, generatedYears } = action.payload;
            state.thisYearGen = thisYearGen;
            state.nextYearGen = nextYearGen;
            state.generatedYears = generatedYears;
        },
        //조회조건
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        clearModifiedHolidays: (state) => {
            state.modifiedHolidays = [];
        },
        removeModifiedHoliday(state, action) {
            state.modifiedHolidays = state.modifiedHolidays.filter(v => v.baseDt !== action.payload);
            
        }
    },
});

export default cod0103m_Slice.reducer;
export const Cod0103mAction  = cod0103m_Slice.actions;
export const Cod0103mReducer = cod0103m_Slice.reducer;
